import { defaultShapeUtils, Tldraw } from "tldraw"
// import { StickerShapeUtil } from "../shapes/StickerShapeUtil"

const WORKER_URL = "http://127.0.0.1:5172"

const roomId = "test-room"

//const shapeUtils = [...defaultShapeUtils, CustomDrawShapeUtil, StickerShapeUtil]

export function TestPage() {
  return (
    <div>
      <h1>Test Page</h1>

      <div style={{ height: "600px" }}>
        <Tldraw />
      </div>
    </div>
  )
}
